import {defineStore} from "pinia";

export const useCart = defineStore("shopping-cart", {
    state: () => ({
        id: "",
        lines: [],
        total_including_vat: 0,
        total_excluding_vat: 0,
        discountable_including_vat: 0,
        discount_excluding_vat: 0,
        discount_including_vat: 0,
        total_vat: 0,
        loaded: false,
        updated_at: null,
        crossSellOpened: false,
    }),
    getters: {
        cartCount(state) {
            return state.productLines.reduce((p, c) => p + c.quantity, 0);
        },
        cartProductLineCount(state) {
            return state.productLines.length;
        },
        productLines(state) {
            return state.lines.filter((l) =>
                l.cartable_type.includes("ProductVariant")
                || l.cartable_type.includes("PackageVariant")
            );
        },
        productVariants(state) {
            return state.productLines.map((l) => {
                return {...l.cartable, quantity: l.quantity,};
            });
        },
        hasCoupon(state) {
            return state.lines.some((l) => l.cartable_type.includes("Coupon"));
        },
        couponCode(state) {
            const coupon = state.lines.find((l) => l.cartable_type.includes("Coupon"));
            return coupon ? coupon.cartable.code : "";
        },
        hasShippingRate(state) {
            return state.lines.some((l) => l.cartable_type.includes("ShippingRate"));
        },
        shippingRate(state) {
            const shippingRate = state.lines.find((l) => l.cartable_type.includes("ShippingRate"));
            return shippingRate ? shippingRate.cartable : null;
        },
        hasProductVariants(state) {
            return state.productLines.length > 0
        },
    },
    actions: {
        load(cart) {
            for (const key in cart) {
                if (Object.hasOwnProperty.call(cart, key)) {
                    this[key] = cart[key];
                }
            }
        },
        getQuantity(product) {
            const productId = typeof product == "string" ? product : product.id;
            const line = this.productLines.find(
                (l) => l.cartable_id === productId
            );
            return line ? line.quantity : 0;
        },
    },
});
